import { Col, List, Row, Skeleton, Space } from "antd";

export const RenderSkeleton = () => {
  const skeletonItemCount = 3; // You can adjust the number of skeleton items as needed
  const skeletonItems = Array.from({ length: skeletonItemCount }).map(
    (_, index) => (
      <List.Item key={index} className="text-start p-0">
        <div className="skeleton-wrapper">
          <div className="skeleton-text">
            <Skeleton.Input style={{ width: "100%", height: "2rem" }} active />
            <Skeleton active paragraph={{ rows: 6 }} />
            <div className="skeleton-icons">
              <Space>
                <Skeleton.Avatar size="small" active />
                <Skeleton.Avatar size="small" active />
                <Skeleton.Avatar size="small" active />
              </Space>
            </div>
          </div>
        </div>
      </List.Item>
    )
  );

  return (
    <div>
      {/* Skeleton layout */}
      <Row gutter={16}>
        <Col span={24} md={16}>
          <List
            itemLayout="vertical"
            size="large"
            pagination={false}
            dataSource={skeletonItems}
            renderItem={(item) => item}
            footer={<div><b>Readings</b></div>}
          />
        </Col>
        <Col
          span={24}
          md={8}
          style={{ position: "sticky", top: "6rem", height: "40vh", background: "#f2f2f2" }}
          className="xs-none"
        >
          {/* The skeleton image should now cover the entire remaining width */}
          <Skeleton.Image style={{ width: "100%", height: "100%" }} active />
        </Col>
      </Row>
    </div>
  );
};
